import RaindropInput from "../raindrop-input/raindrop-input.tsx";
import ModelComponent from "../model-component/model-component.tsx";
import { localize } from "../../services/localize.js";
import RaindropButton from "../raindrop-button/raindrop-button.tsx";
import { fetchGraphQL } from "../../services/api-raindrop.js";

const ModelComponentOrganisationTag = ({ id, value, rawData = null }) => {
  const onRemoveTag = () => {
    fetchGraphQL(`
      mutation {
        organisationTagRemove(organisationTagId: "${id}") {
          id
        }
      }
    `)
      .then((response) => {
        document.location.reload();
      })
      .catch((error) => {
        console.error("Error removing organisation tag", error);
      });
  };

  return (
    <ModelComponent
      modelId={id}
      colorBorderAccent="border-l-color-model-organisation-tag dark:border-l-color-dark-model-organisation-tag"
      rawData={rawData}
      helperText={localize(value)}
    >
      <RaindropInput
        label="Value"
        value={value}
        isEditing={false}
        isShowLabel={true}
      />
      <RaindropButton title="Remove Tag" onClick={onRemoveTag} />
    </ModelComponent>
  );
};

export default ModelComponentOrganisationTag;
